import React, {FC, memo, useMemo} from 'react';

import {WEAVE_TITLE} from '../../../../routes/paths';
import {trackBreadcrumbClicked} from '../../../../util/navigation';
import * as links from '../../../../util/urls';
import Breadcrumbs, {BreadcrumbPart} from '../../../Breadcrumbs';

export type NavBreadcrumbsFlowsProps = {
  entityName: string;
  projectName: string;
  flowsTab?: string;
  itemName?: string;
  version?: string;
  refExtra?: string;
};

const NavBreadcrumbsFlowsComp: FC<NavBreadcrumbsFlowsProps> = params => {
  const {entityName, projectName, flowsTab, itemName, version, refExtra} =
    params;
  const parts: BreadcrumbPart[] = useMemo(
    () => [
      {
        label: entityName,
        to: `/${entityName}`,
        onClick: () => trackBreadcrumbClicked('Entity'),
      },
      {
        label: projectName,
        to: links.project({entityName, name: projectName}),
        onClick: () => trackBreadcrumbClicked('Project'),
      },
      {
        label: WEAVE_TITLE,
        to: links.flowsView({
          entityName,
          projectName,
        }),
        onClick: () => trackBreadcrumbClicked(WEAVE_TITLE),
      },
      ...(flowsTab
        ? [
            {
              label: flowsTab,
              to: links.flowsView({
                entityName,
                projectName,
                flowsTab,
              }),
            },
            ...(itemName
              ? [
                  {
                    label: itemName,
                    to: links.flowsView({
                      entityName,
                      projectName,
                      flowsTab,
                      itemName,
                    }),
                  },
                  ...(version
                    ? [
                        {
                          label: version,
                          to: links.flowsView({
                            entityName,
                            projectName,
                            flowsTab,
                            itemName,
                            version,
                          }),
                        },
                        ...(refExtra
                          ? [
                              {
                                label: refExtra,
                                to: links.flowsView({
                                  entityName,
                                  projectName,
                                  flowsTab,
                                  itemName,
                                  version,
                                  refExtra,
                                }),
                              },
                            ]
                          : []),
                      ]
                    : []),
                ]
              : []),
          ]
        : []),
    ],
    [entityName, flowsTab, itemName, projectName, refExtra, version]
  );

  return <Breadcrumbs parts={parts} />;
};

const NavBreadcrumbsFlows = memo(NavBreadcrumbsFlowsComp);

export default NavBreadcrumbsFlows;
